import React, { useState } from "react";
import "./nav.css";
import { ImHome } from "react-icons/im";
import { RiUserLine } from "react-icons/ri";
import { FaBook } from "react-icons/fa6";
import { FaProjectDiagram } from "react-icons/fa";

function Nav() {
  const [active, setActive] = useState("#");

  return (
    <nav>
      <a
        href="#"
        className={active === "#" ? "active" : ""}
        onClick={() => setActive("#")}
      >
        <ImHome size={20} />
      </a>
      <a
        href="#about"
        className={active === "#about" ? "active" : ""}
        onClick={() => setActive("#about")}
      >
        <RiUserLine size={20} />
      </a>
      <a
        href="#experience"
        className={active === "#experience" ? "active" : ""}
        onClick={() => setActive("#experience")}
      >
        <FaBook size={20} />
      </a>
      <a
        href="#portfolio"
        className={active === "#portfolio" ? "active" : ""}
        onClick={() => setActive("#portfolio")}
      >
        <FaProjectDiagram size={20} />
      </a>
    </nav>
  );
}

export default Nav;
